export default __webpack_public_path__ + "static/media/profilephoto.ed50ac25.jpg";